import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationDistancePluginService } from './distance.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'installation-distance-edit',
    templateUrl: './distance-edit.component.html',
    standalone: false
})
export class InstallationDistanceEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  distances: any[];

  private sub = new Subscription();

  @ViewChild('distancesModal', { static: true }) distancesModal: ModalComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationDistancePluginService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateDistance(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public onClose(e: any) {
    this.editForm.controls['distance'].markAsTouched();
  }

  public openDistancesSelector() {
    this.openSelector(this.distancesModal, this.distances, this.editForm.controls.distance.value);
  }

  public selectDistancesMenu(item: any) {
    const selectedIndex = this.editForm.controls.distance.value === item.selectedIndex ? '' : item.selectedIndex;
    this.editForm.controls.distance.setValue(selectedIndex);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.distances = this.pluginService.getDistances();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      label: new UntypedFormControl(this.plugin.config.Label ?? ''),
      distance: new UntypedFormControl(this.plugin.config.Distance ? this.plugin.config.Distance : '')
    });
  }
}
